import {Hazard, Risk} from '@domain/hroc-checklists'
import {ValidationErrorKeys} from '@hconnect/common/consts'
import {type TFunction} from 'i18next'
import {object, string, array} from 'yup'

const WORK_TO_BE_DONE_MAX_LENGTH = 512
const OTHER_HAZARDS_MAX_LENGTH = 512
const OTHER_RISKS_MAX_LENGTH = 512
const ELIMINATE_CONTROL_HAZARD_MAX_LENGTH = 512

export const getHazardAssessmentValidationSchema = ({t}: {t: TFunction}) =>
  object().shape({
    workToBeDone: string()
      .max(
        WORK_TO_BE_DONE_MAX_LENGTH,
        t(ValidationErrorKeys.MAX_LENGTH, {max: WORK_TO_BE_DONE_MAX_LENGTH})
      )
      .required(t(ValidationErrorKeys.REQUIRED)),
    hazards: array().min(1, t(ValidationErrorKeys.REQUIRED)),
    hazardsComment: string().when('hazards', {
      is: (value: {id: Hazard}[]) => value?.some(({id}) => id === Hazard.Other),
      then: string()
        .required(t(ValidationErrorKeys.REQUIRED))
        .max(
          OTHER_HAZARDS_MAX_LENGTH,
          t(ValidationErrorKeys.MAX_LENGTH, {max: OTHER_HAZARDS_MAX_LENGTH})
        ),
      otherwise: string().max(
        OTHER_HAZARDS_MAX_LENGTH,
        t(ValidationErrorKeys.MAX_LENGTH, {max: OTHER_HAZARDS_MAX_LENGTH})
      )
    }),
    risks: array().min(1, t(ValidationErrorKeys.REQUIRED)),
    risksComment: string().when('risks', {
      is: (value: {id: Risk}[]) => value?.some(({id}) => id === Risk.Other),
      then: string()
        .required(t(ValidationErrorKeys.REQUIRED))
        .max(
          OTHER_RISKS_MAX_LENGTH,
          t(ValidationErrorKeys.MAX_LENGTH, {max: OTHER_RISKS_MAX_LENGTH})
        ),
      otherwise: string().max(
        OTHER_RISKS_MAX_LENGTH,
        t(ValidationErrorKeys.MAX_LENGTH, {max: OTHER_RISKS_MAX_LENGTH})
      )
    }),
    eliminateControlHazard: string()
      .max(
        ELIMINATE_CONTROL_HAZARD_MAX_LENGTH,
        t(ValidationErrorKeys.MAX_LENGTH, {max: ELIMINATE_CONTROL_HAZARD_MAX_LENGTH})
      )
      .required(t(ValidationErrorKeys.REQUIRED))
  })
